/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 15/03/2018.
*
* layouts-create-view Vue Component
*/
<template>
  <form-modal
    :hide-secondary-button="true"
    primary-button-label="Crear periodo"
    modal-title="Crear periodo"
    @closeModal="onCloseModal"
    @primaryButtonClick="onSave">
    <div class="content">
      <periods-form ref="form"/>
    </div>
  </form-modal>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import FormModal from '@/components/_shared/form-modal'
import PeriodsForm from '@/modules/periods/periods-form'
export default {
  name: 'PeriodsCreateView',
  components: {FormModal, PeriodsForm},
  methods: {
    onCloseModal () {
      this.$router.push({name: 'periods'})
    },
    onSave () {
      this.$refs.form.onSubmit()
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  .content{
    padding: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/app/periods/periods-create-view.vue